import { Component, OnInit, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


@Component({
    selector: 'app-solar',
    templateUrl: './solar.component.html',
    styleUrls: ['./solar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SolarComponent implements OnInit, AfterViewInit {

  id: number;

  constructor(private actRoute: ActivatedRoute) {
      this.id = this.actRoute.snapshot.params.id;
    }

  ngAfterViewInit() {
      console.log(this.id);
    }

  ngOnInit() {
  }

}
